<template>
  <div class="banner">
    <b-row>
      <b-col cols="4">
        <p class="text-header">จัดการที่ว่างต่อสาขา</p>
      </b-col>
    </b-row>
    <div class="tw-bg-white tw-mt-4 p-3">
      <b-row>
        <b-col class="d-flex align-items-center">
          <div class="text-header">ข้อมูลพื้นฐาน</div>
          <font-awesome-icon
            class="ml-3 pointer"
            icon="pen"
            @click="onClickCreate"
          />
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="6">
          <div class="text-label">ชื่อ</div>
          <div>{{ slotDetail.name }}</div>
        </b-col>
        <b-col cols="6">
          <div class="d-flex justify-content-between">
            <div>
              <div class="text-label">จำนวนที่ว่าง</div>
              <div>{{ slotDetail.defaultSlot || "ไม่จำกัด" }}</div>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col cols="4">
          <p class="text-header">กำหนดที่ว่างพิเศษตามวัน</p>
        </b-col>
        <b-col cols="8">
          <div class="d-flex justify-content-end">
            <b-button class="btn-filter" @click="$refs.sidebarFilter.show()">
              <span class="d-none d-md-block">
                <span class="">ตัวกรอง</span>
              </span>
            </b-button>

            <b-button class="btn-filter ml-2" @click="onClickCreateDate">
              <span class="d-none d-md-block">
                <span>สร้าง</span>
              </span>
            </b-button>
          </div>
        </b-col>
      </b-row>
      <Table
        :items="items"
        :fields="fields"
        :isBusy="isBusy"
        :rows="rows"
        :filter="filter"
        :pageOptions="pageOptions"
        @edit="onEditExtraDate"
        @editCategory="onClickEditCategory"
        @filterPage="filterPage"
        @onChangeStatus="onChangeStatus"
      />
    </div>

    <SlotForm
      key="SlotForm"
      :visible="visible"
      :id="parseInt($route.params.id)"
      :data="slotDetail"
      @hideForm="hideForm"
      @fetchTable="getData"
    />
    <ExtradateForm
      key="ExtradateForm"
      ref="ExtradateFormSidebar"
      :visible="extraDatevisible"
      :id="parseInt($route.params.id)"
      :data="extraDateDetail"
      @hideForm="hideForm"
      @fetchTable="getData"
      @handleOverlap="handleOverlap"
    />

    <SideBarFilter
      :filter="filter"
      ref="sidebarFilter"
      placeholder="Transaction"
      @searchAll="handleOverlap"
      @clearFilter="clearFilter"
      :hideStatusFilter="false"
      :hideSearchBar="true"
    >
      <template v-slot:filter-option>
        <div class="my-3">
          <div class="font-weight-bold mb-1">วัน</div>
          <div :class="['input-container']">
            <datetime
              v-model="filter.date"
              :input-style="styleDatetime"
              format="dd/MM/yyyy"
              value-zone="local"
              placeholder="กรุณาเลือกวัน"
              ref="date"
            >
            </datetime>
            <div
              class="icon-primary text-right"
              @click="$refs.date.isOpen = true"
            >
              <font-awesome-icon
                icon="calendar-alt"
                class="pointer g-text-gold"
                color="#B41BB4"
              />
            </div>
          </div>
        </div>
        <div class="my-3">
          <div class="label mb-2">เวลาเริ่มต้น</div>
          <div :class="['input-container']">
            <datetime
              v-model="filter.timeStart"
              :input-style="styleDatetime"
              value-zone="local"
              placeholder="กรุณาเลือกเวลาเริ่มต้น"
              ref="timeStart"
              type="time"
            >
            </datetime>
            <div
              class="icon-primary text-right"
              @click="$refs.timeStart.isOpen = true"
            >
              <font-awesome-icon
                icon="calendar-alt"
                class="pointer g-text-gold"
                color="#B41BB4"
              />
            </div>
          </div>
        </div>
        <div class="my-3">
          <div class="font-weight-bold mb-1">เวลาสิ้นสุด</div>
          <div :class="['input-container']">
            <datetime
              v-model="filter.timeEnd"
              :input-style="styleDatetime"
              type="time"
              value-zone="local"
              placeholder="กรุณาเลือกเวลาสิ้นสุด"
              ref="timeEnd"
            >
            </datetime>
            <div
              class="icon-primary text-right"
              @click="$refs.timeEnd.isOpen = true"
            >
              <font-awesome-icon
                icon="calendar-alt"
                class="pointer g-text-gold"
                color="#B41BB4"
              />
            </div>
          </div>
        </div>
        <div class="my-3">
          <InputSelect
            title="สถานะ"
            name="สถานะ"
            class="mt-2"
            v-model="filter.isActive"
            v-bind:options="optionStatus"
            valueField="value"
            textField="name"
          >
            <template v-slot:option-first>
              <b-form-select-option :value="null">All </b-form-select-option>
            </template>
          </InputSelect>
        </div>
      </template>
    </SideBarFilter>
  </div>
</template>

<script>
import Table from "./component/table.vue";
import SlotForm from "./component/slotForm.vue";
import ExtradateForm from "./component/ExtradateForm.vue";
export default {
  name: "CategoryPage",
  components: {
    Table,
    SlotForm,
    ExtradateForm,
  },
  data() {
    return {
      styleDatetime: {
        width: "100%",
        border: "none",
      },
      //state
      tabIndex: 0,
      id: 0,

      // state toggle
      iconSearch: false,
      visible: false,
      extraDatevisible: false,
      optionStatus: [
        { value: true, name: "Active" },
        { value: false, name: "InActive" },
      ],

      // state table
      items: [],
      fields: [
        {
          key: "date",
          label: "วันที่",
          class: "w-100px text-nowrap",
        },
        {
          key: "timeStart",
          label: "เวลาเริ่มต้น",
          class: "w-100px text-nowrap",
        },
        {
          key: "timeEnd",
          label: "เวลาสิ้นสุด",
          class: "w-100px text-nowrap",
        },
        {
          key: "slotQuantity",
          label: "จำนวนที่ว่าง",
          class: "w-100px text-nowrap",
        },
        {
          key: "status",
          label: "สถานะ",
          class: "w-50px text-nowrap",
        },
        { key: "slotactions", label: "ดำเนินการ", class: "w-50px text-nowrap" },
      ],

      pageOptions: [
        { value: 5, text: "5 / หน้า" },
        { value: 10, text: "10 / หน้า" },
        { value: 15, text: "15 / หน้า" },
        { value: 20, text: "20 / หน้า" },
      ],
      isBusy: false,
      filter: {
        date: null, //"2025-06-13",
        timeStart: null, //"10:00:00",
        timeEnd: null, //"10:59:59",
        isActive: null, //true,false
        page: 1,
        take: 10,
      },
      rows: 0,

      // state modal
      textModal: "",
      arrStatus: [],
      isLoading: false,
      slotDetail: {
        name: "",
        defaultSlot: null,
      },
      extraDateDetail: {
        id: 0,
        date: "",
        timeStart: "",
        timeEnd: "",
        slotQuantity: 0,
        isActive: false,
        eventSlotGroupId: this.$route.query.type,
      },
    };
  },

  mounted() {
    this.getData();
  },
  methods: {
    clearFilter() {
      this.filter = {
        date: null,
        timeStart: null, //"10:00:00",
        timeEnd: null, //"10:59:59",
        isActive: null, //true,false
        page: 1,
        take: 10,
      };
      this.$refs.sidebarFilter.hide();
      this.getList();
    },
    isTimeFormat(text) {
      const timeRegex = /^([01]\d|2[0-3]):[0-5]\d:[0-5]\d$/;
      return timeRegex.test(text);
    },
    handleOverlap(item) {
      this.filter = {
        ...this.filter,
        date: item.date ? this.$moment(item.date).format("YYYY-MM-DD") : null,
        timeStart: item.timeStart
          ? this.isTimeFormat(item.timeStart)
            ? item.timeStart
            : this.$moment(item.timeStart).format("HH:mm:ss")
          : null,
        timeEnd: item.timeEnd
          ? this.isTimeFormat(item.timeEnd)
            ? item.timeEnd
            : this.$moment(item.timeEnd).format("HH:mm:ss")
          : null,
        isActive: true,
        page: 1,
      };
      this.$refs.sidebarFilter.hide();
      this.getList();
    },
    onEditExtraDate(item) {
      this.extraDateDetail = item;
      this.extraDatevisible = true;
    },
    getData() {
      this.getList();
      this.getSlotDetail();
    },
    async getSlotDetail() {
      this.isLoading = true;
      const respone = await this.$services.slotgroup.getSlotGroupDetail(
        this.$route.params.id
      );
      if (respone.result === 1) {
        this.slotDetail = respone.detail;
      }
      this.isLoading = false;
    },
    async getList() {
      this.isBusy = true;
      const respone = await this.$services.slotgroup.getExtraDateList(
        {
          ...this.filter,
          date: this.filter.date || null,
          timeStart: this.filter.timeStart || null,
          timeEnd: this.filter.timeEnd || null,
        },
        this.$route.params.id
      );
      if (respone.result === 1) {
        const { data, count, skip, take } = respone.detail;
        this.items = data;

        this.rows = count;
      }
      this.isBusy = false;
    },
    handleSearch() {
      this.filter.page = 1;
      this.getList();
    },
    onClickEditCategory(val) {
      const { id } = val;
      this.id = id;
      this.visible = true;
    },
    onClickCreate() {
      this.visible = true;
    },
    onClickCreateDate() {
      this.extraDateDetail = {
        id: 0,
        date: "",
        timeStart: "",
        timeEnd: "",
        slotQuantity: 0,
        isActive: false,
        eventSlotGroupId: this.$route.query.type,
      };
      this.extraDatevisible = true;
    },
    filterPage(obj) {
      let { page } = obj;
      this.filter.page = page;

      this.getList();
    },
    onChangeStatus(item) {
      this.extraDateDetail = item;
      this.$refs.ExtradateFormSidebar.onChangeStatus(item);
    },
    hideForm() {
      this.id = 0;
      this.visible = false;
      this.extraDatevisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  .g-form {
    width: 100%;
    margin-right: 10px;
  }
  .text-header {
    color: #092d53;
    font-weight: 600;
    font-size: 20px;
    text-transform: uppercase;
  }
  .div-divide {
    border-bottom: 1px solid darkgray;
    padding: 10px 0px;
  }

  .header-title {
    display: flex;
    justify-content: space-between;
    padding: 10px 0px;
  }

  .render-image {
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    height: 200px;
    border: 1px dashed gray;
  }
}
</style>
